<template>
    <div class="head-container">

    </div>
</template>
<script>
import bus from "../bus"

export default {
    data() {
        return {

        }
    },
    mounted() {
        this.$emit('languageChange',{
            language: 1
        })
    }
}
</script>
<style scoped>
    
</style>
